<template>
	<div>
		<div class="crumbs">
			<el-breadcrumb separator="/">
				<!-- 页面名称 -->
				<el-breadcrumb-item v-for="(item,index) in lblMBA" :key="index" v-if="'lbl0'==item.MBAOBJNM" >
					<i class="el-icon-lx-shop"></i>
					{{item.MBAVALUE}}
				</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="container">
			<el-form :model="query" :rules="rules" ref="query" style ="height: 240px;">
				<div class="handle-box">
					<el-row>
						<!-- 检索标签+分割线 -->
						<h2 style="color: #b6b6b6;height: 32px;" v-for="(item,index) in lblMBA" :key="index" v-if="'lbl1'==item.MBAOBJNM && '0'==item.MBADSPFG" >{{item.MBAVALUE}}</h2>
						<el-divider></el-divider>
						<el-col>
							<el-col :span="24" style="max-height: 25px;" v-for="(item,index) in lblMBA" :key="index" v-if="'lbl2'==item.MBAOBJNM && '0'==item.MBADSPFG">
								<!-- 売上日付 -->
								<el-col :span="3">
									<span >{{item.MBAVALUE}}</span>
								</el-col>
								<!-- 开始时间 -->
								<el-col :span="7">
									<div class="grid-content " style="width: 260px;">
										<el-form-item prop="start">
											<el-date-picker v-model="query.start"  :clearable="false" type="date" value-format="yyyy-MM-dd" class="handle-time mr10 "></el-date-picker>
										</el-form-item>
									</div>
								</el-col>
								<el-col :span="1"><span>-</span></el-col>
								<!-- 结束时间 -->
								<el-col :span="7">
									<div class="grid-content " style="width: 260px;">
										<el-form-item prop="end">
											<el-date-picker v-model="query.end"  :clearable="false" type="date" value-format="yyyy-MM-dd" class="handle-time mr10"></el-date-picker>
										</el-form-item>
									</div>
								</el-col>
								<el-col :span="24" style = "margin-top: 20px;" v-for="(item,index) in lblMBA" :key="index" v-if="'lbl12'==item.MBAOBJNM && '0'==item.MBADSPFG">
									<!-- 購入関連 -->
									<el-col :span="3">
										<span >{{item.MBAVALUE}}</span>
									</el-col>
									<el-col :span="4" v-for="(item,index) in lblMBA" :key="index" v-if="'lbl13'==item.MBAOBJNM && '0'==item.MBADSPFG">
										<el-select v-model="query.POS01"  :placeholder="item.MBAVALUE">
											<el-option v-for="item in query.optionsPOS01" :key="item.INIKEY02" :label="item.INIVALUE" :value="item.INIKEY02" ></el-option>
										</el-select>
									</el-col>
									<el-col :span="4" style = "margin-left: 10px;"  v-for="(item,index) in lblMBA" :key="index" v-if="'lbl14'==item.MBAOBJNM && '0'==item.MBADSPFG">
										<el-select v-model="query.POS02" :placeholder="item.MBAVALUE">
											<el-option v-for="item in query.optionsPOS02" :key="item.INIKEY02" :label="item.INIVALUE" :value="item.INIKEY02"></el-option>
										</el-select>
									</el-col>
									<el-col :span="4" style = "margin-left: 10px;" v-for="(item,index) in lblMBA" :key="index" v-if="'lbl15'==item.MBAOBJNM && '0'==item.MBADSPFG">
										<el-select v-model="query.POS03"  :placeholder="item.MBAVALUE">
											<el-option v-for="item in query.optionsPOS03" :key="item.INIKEY02" :label="item.INIVALUE" :value="item.INIKEY02"></el-option>
										</el-select>
									</el-col>
									<el-col :span="4" style = "margin-left: 10px;"  v-for="(item,index) in lblMBA" :key="index" v-if="'lbl16'==item.MBAOBJNM && '0'==item.MBADSPFG">
										<el-select v-model="query.POS04" :placeholder="item.MBAVALUE">
											<el-option v-for="item in query.optionsPOS04" :key="item.INIKEY02" :label="item.INIVALUE" :value="item.INIKEY02"></el-option>
										</el-select>
									</el-col>
									<el-col :span="24" style = "margin-top: 40px;">
										<!-- 返金があるものを除外する -->
										<template>
											<el-checkbox v-model="query.pDELFG" v-for="(item,index) in lblMBA" :key="index" v-if="'lbl20'==item.MBAOBJNM && '0'==item.MBADSPFG" :label="item.MBAVALUE"><span>{{item.MBAVALUE}}</span></el-checkbox>
										</template>
									</el-col>
									
								</el-col>
							</el-col>								
						</el-col>
					</el-row>
				</div>
				<div class="handle-box">
					<el-row>
						<!-- 检索标签+分割线 -->
						<h2 style=" height: 32px;" ></h2>
						<el-divider></el-divider>
						<el-col>
							<el-col :span="24" v-for="(item,index) in lblMBA" :key="index" v-if="'lbl3'==item.MBAOBJNM && '0'==item.MBADSPFG">
								<!-- 店铺 -->
								<el-col :span="4">
									<span >{{item.MBAVALUE}}</span>
								</el-col>
								<el-col :span="9">
									<el-select class="col-width" v-model="query.MCCID"  multiple>
										<el-option v-for="item in query.optionsMCCID" :key="item.MCCMSTID" :label="item.MCCMNAME" :value="item.MCCMSTID"></el-option>
									</el-select>
								</el-col>
							</el-col>
							<el-col :span="24" style = "margin-top: 20px;" v-for="(item,index) in lblMBA" :key="index" v-if="'lbl22'==item.MBAOBJNM && '0'==item.MBADSPFG">
								<!-- 店舗グループ -->
								<el-col :span="4">
									<span >{{item.MBAVALUE}}</span>
								</el-col>
								<el-col :span="9">
									<el-select class="col-width" v-model="query.MCDID"  multiple>
										<el-option v-for="item in query.optionsMCDID" :key="item.MCDMSTID" :label="item.MCDMNAME" :value="item.MCDMSTID"></el-option>
									</el-select>
								</el-col>
							</el-col>	
							<el-col :span="24" style = "margin-top: 20px;" v-for="(item,index) in lblMBA" :key="index" v-if="'lbl23'==item.MBAOBJNM && '0'==item.MBADSPFG">
								<!-- 会員ランク-->
								<el-col :span="4">
									<span >{{item.MBAVALUE}}</span>
								</el-col>
								<el-col :span="9">
									<el-select class="col-width" v-model="query.PBARNKCT"  multiple>
										<el-option v-for="item in query.optionsPBARNKCT" :key="item.INIKEY02" :label="item.INIVALUE" :value="item.INIKEY02"></el-option>
									</el-select>
								</el-col>
							</el-col>
						</el-col>
						<el-col>
						</el-col>
					</el-row>
				</div>
			</el-form>
		</div>
		<div class="container">
			<div v-if="showCompanyIds.includes(pCOMID)">			
				<el-col :span="24" >
					<!-- 为提升 AI 预测效果，推荐采用一年的时间间隔进行预测。 -->
					<span style=" font-size: 15px; margin-left: 6px; vertical-align: middle;">AI予測の精度向上のため、
					原則として1年以上の販売実績データを基に予測を行うことを推奨します。
					</span>
					<br>
					<span style=" font-size: 15px; margin-left: 6px; vertical-align: middle;">
					※蓄積されたデータ量が多いほど、予測結果の参考性は高まりますが、
					本予測結果はあくまで業務判断を支援するための参考情報です。</span>
				</el-col>
				<el-button style="margin-top: 5px; margin-left: 10px;" type="primary" icon="el-icon-data-analysis" @click="openAIForecast('month')">
					月次売上予測（AI）
				</el-button>	
				<span style="color: #f56c6c; font-size: 12px; margin-left: 6px; vertical-align: middle;">※予測には、7か月以上の販売データが必要です。</span>
				<el-button style="margin-top: 15px; margin-left: 10px;" type="success" icon="el-icon-data-analysis" @click="openAIForecast('week')">
				週次売上予測（AI）
				</el-button>				
				<span style="color: #f56c6c; font-size: 12px; margin-left: 6px; vertical-align: middle;">※予測には、10週間以上の販売データが必要です。</span>										
				<el-divider></el-divider>	
			</div>
					
			<itemfileselected ref="itemfile" :datarow="datarow" :datacol="datacol" :orderitem="orderitem" :checkitem="checkitem"
			 :sussdata="collist">
			</itemfileselected>

			<div v-if="datasource.length>0">
				<el-button style="margin-top: 20px;" type="success" @click="exportcsv()" v-for="(item,index) in lblMBA" :key="index" v-if="'lbl19'==item.MBAOBJNM" >{{item.MBAVALUE}}</el-button>
				<div class="pagination">
					<el-pagination background @size-change="handleSizeChange" @current-change="handlePageChange" :current-page="this. query.pageIndex"
					 :page-sizes="[10, 50, 100]" :page-size="this.query.pageSize" layout="total, sizes, prev, pager, next, jumper"
					 :total="this.query.total">
					</el-pagination>
				</div>
			</div>
		</div>
		<!-- 新增AI预测弹窗：整合月/周预测，仅改单选框绑定 -->
		<el-dialog
			title="AI売上予測分析"
			:visible.sync="aiForecastDialogVisible"
			width="80%"
			top="20px"
			:before-close="closeAIForecastDialog"
		>
			<!-- 【周预测改造】单选框label根据类型切换，绑定统一变量aiForecastNum -->
			<el-form :model="aiForecastForm" inline style="margin-bottom: 20px;">
				<el-form-item :label="aiForecastType === 'month' ? '予測月数：' : '予測週数：'">
					<el-radio-group v-model="aiForecastForm.aiForecastNum" @change="getAIForecastData" :disabled="aiForecastLoading">
						<el-radio label="1">{{aiForecastType === 'month' ? '1ヶ月' : '1週間'}}</el-radio>
						<el-radio label="2">{{aiForecastType === 'month' ? '2ヶ月' : '2週間'}}</el-radio>
						<el-radio label="3">{{aiForecastType === 'month' ? '3ヶ月' : '3週間'}}</el-radio>
						<el-radio label="4">{{aiForecastType === 'month' ? '4ヶ月' : '4週間'}}</el-radio>
						<el-radio label="5">{{aiForecastType === 'month' ? '5ヶ月' : '5週間'}}</el-radio>
						<el-radio label="6">{{aiForecastType === 'month' ? '6ヶ月' : '6週間'}}</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="getAIForecastData" :loading="aiForecastLoading">再計算</el-button>
				</el-form-item>
			</el-form>
			<!-- ECharts图表容器：历史+预测趋势  增加v-loading覆盖，解决线性加载闪烁 -->
			<div id="aiForecastChart" style="width: 100%; min-height: 350px;" v-loading="aiForecastLoading" element-loading-text="AI予測データ読み込み中..." element-loading-background="rgba(255,255,255,0.8)"></div>
			<!-- 预测明细表格 ：增加无数据友好提示-->
			<el-table
				:data="aiForecastTableData"
				border
				style="width: 100%; margin-top: 20px;"
				size="small"
				v-if="aiForecastTableData.length > 0 || !aiForecastLoading"
			>
				<el-table-column prop="Period" label="予測期間" align="center" width="150"></el-table-column>
				<el-table-column prop="ForecastAmount" label="予測税抜金額" align="right" :formatter="MONEYformatter">							
				</el-table-column>
				<el-table-column prop="ForecastCount" label="予測数量" align="center" :formatter="QUATYformatter"></el-table-column>
			</el-table>
			<!-- 表格无数据友好提示 -->
			<div class="ai-empty-tip" style="text-align: center; padding: 30px; color: #999;" v-if="aiForecastTableData.length === 0 && !aiForecastLoading">
				<i class="el-icon-info" style="font-size: 20px; margin-bottom: 10px;"></i>
				<p>該当するAI予測データはありません</p>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import itemfileselected from '@/components/common/itemfileselected.vue';
		// 引入ECharts核心
	import * as echarts from 'echarts';
	export default {
		name: 'Analysissales',
		inject: ['reload'],

		data() {
			//验证字符串
			const validatestart = (rule, value, callback) => {
				if (value == '' || value == undefined || value == null) {
					callback(this.$t('Message.Message_05'));
				} else {
					callback();
				}
			};

			const validateend = (rule, value, callback) => {
				if (value == '' || value == undefined || value == null) {
					callback(this.$t('Message.Message_05'));
				} else {
					callback();
				}
			};

			return {

				pMECPRTID: '',
				pMEDPPRID: '',
				pMEDPRTID: '',
				//	pLNGCT: sessionStorage.getItem('ms_lang'),  //web侧 语言
				query: {

					pageIndex: 1,
					pageSize: 100,
					total: 0,

					MCCID: [], //店铺
					optionsMCCID: [], //店铺取值
					MCDID: [], //店铺グループ
					optionsMCDID: [], //店铺グループ取值
					/* MEAID: [], //メーカー
					optionsMEAID: [], //メーカー取值
					MEBID: '', //大分类
					optionsMEBID: [], //大分类取值
					MECID: '', //中分类
					optionsMECID: [], //中分类取值
					MEDID: '', //小分类
					optionsMEDID: [], //小分类取值
					MDAID:'',//品番
					MEENM: '', //原作S
					MDHNM1: '', //品名1
					MDHNM2: '', //品名2 */
					POS01: '', //性别
					optionsPOS01: [], //性别
					POS02: '', //需要
					optionsPOS02: [], //需要
					POS03: '', //客層
					optionsPOS03: [], //客層
					POS04: '', //年代
					optionsPOS04: [], //年代
					MDMNM: '', //シーズン
					start: '', //时间开始
					end: '', //结束开始
					hfShopCD: '',
					count: 0,	
					pDELFG:false ,//返金があるものを除外する					
					PBARNKCT: [], //会員ランク
					optionsPBARNKCT: [], //会員ランク取值
				},
				// pagesql: '', //页面SQL
				// isbtnEnabled: true, //检索按钮控制
				ShopCD: '',
				pMCBID: sessionStorage.getItem("UserCD"), //b0211f
				pMCCID: sessionStorage.getItem('ShopCD'),
				pCOMLG: sessionStorage.getItem("COMLG"), //30126
				pLNGCT: sessionStorage.getItem("Language"), //语言
				pCOMID: sessionStorage.getItem("CompanyCD"), //语言
				showCompanyIds:['001','099','147','365','752'],
				collist: [],
				datasource: [],

				rows: '',
				cols: '',
				jjs: '',
				rpx: '',
				valtype: '',

				datarow: [], //行
				datacol: [], //列
				checkitem: [], //集计
				lblMBA:[],//MBA标签
				strMBB:'',//提示语
				strType:'',//提示类型
				PAGENAME: '',

				orderitem: [{
						INITXT01: 'ASC',
						INIVALUE: this.$t("Analysissales.Analysissales_0"),


					},
					{
						INITXT01: 'DESC',
						INIVALUE: this.$t("Analysissales.Analysissales_1"),

					}
				],

				//验证规则
				rules: {
					// start: [
					// 	{
					// 		required: true,
					// 		trigger: ['blur', 'change'],
					// 		validator: validatestart
					// 	}
					// ],
					// end: [
					// 	{
					// 		required: true,
					// 		trigger: ['blur', 'change'],
					// 		validator: validateend
					// 	}
					// ]
				},
				// ===== AI预测相关：【周预测改造】整合月/周变量 =====
				aiForecastDialogVisible: false, //AI弹窗显隐
				aiForecastType: 'month', // 核心标识：month=月预测，week=周预测
				aiForecastForm: {
					aiForecastNum: '1' // 统一存储预测数（月/周），替代原forecastMonths
				},
				aiForecastChart: null, //ECharts实例
				aiForecastTableData: [] ,//AI预测明细表格数据
				aiForecastLoading: false, // AI预测全局加载状态（核心优化：替代局部loading，解决线性加载）
				resizeTimer: null // 抽离resize定时器，避免重复创建（优化）
			};
		},
		
		components: {
			itemfileselected
		},
		
		//国际化
		computed: {
			i18n() {
				return this.$t('Analysissales');
			},
			//时间
			starttimeDefault() {
				var date = new Date();
				var datetime = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + 1;
				return datetime;
			},
			endtimeDefault() {
				var date = new Date();
			  var datetime = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + new Date(date.getFullYear(),(date.getMonth() + 1).toString().padStart(2,'0'),0).getDate();
				return datetime;
			}
		},
		
		created() {
			this.Get_MBA('SalesShop');
			this.query.start = this.starttimeDefault;
			this.query.end = this.endtimeDefault;
			this.Get_MCC_List(); //店铺取值
			this.Get_MCD_List(); //店铺取值
			this.Get_INI1_List(); //性别取值
			this.Get_INI2_List(); //需要取值
			this.Get_INI3_List(); //客層取值
			this.Get_INI4_List(); //年代取值
			this.Get_INI5_List(); //会員ランク
			this.Get_INI();
			this.Get_BAG_List(); //获取页面名
		},
		// 优化：弹窗打开时监听resize，关闭时移除，避免内存泄漏
		watch: {
			aiForecastDialogVisible(newVal) {
				if (newVal) {
					// 弹窗打开时添加resize监听
					window.addEventListener('resize', this.handleChartResize);
				} else {
					// 弹窗关闭时移除resize监听，清空定时器
					window.removeEventListener('resize', this.handleChartResize);
					clearTimeout(this.resizeTimer);
				}
			}
		},
	
		// 优化：组件销毁时强制销毁图表和监听，避免内存泄漏
		beforeDestroy() {
			if (this.aiForecastChart) {
				this.aiForecastChart.dispose();
				this.aiForecastChart = null;
			}
			window.removeEventListener('resize', this.handleChartResize);
			clearTimeout(this.resizeTimer);
		},
	
		methods: {			
			// ===== 原有方法全部保留，以下是新增AI预测相关方法 =====
			// 初始化AI预测ECharts图表																						
			initAIForecastChart() {
			  const chartDom = document.getElementById('aiForecastChart');
			  if (!chartDom) return;
			  // 销毁旧实例，避免重复创建导致的渲染异常（核心优化：解决多次打开弹窗的图表问题）
			 if (this.aiForecastChart) {
			  this.aiForecastChart.dispose();
			 }
			  this.aiForecastChart = echarts.init(chartDom);
			  // 货币符号兜底
			  var moneyMark = sessionStorage.getItem('MoneyMark') || '￥';
			  // 基础配置
			  const baseOption = {
			    title: {
			      text: '売上履歴 + AI予測趨勢（税抜金額/数量）',
			      left: 'center',
			      textStyle: { fontSize: 14 } // 标题字号缩小，避免占空间
			    },
			    tooltip: { trigger: 'axis', axisPointer: { type: 'cross' },
				 // 格式化tooltip，显示千分位+货币符号
				      formatter: function(params) {
				        var res = params[0].name;
				        for (var i = 0; i < params.length; i++) {
				          var item = params[i];
				          var val = item.seriesName.indexOf('金額') > -1 ? Number(item.value).toLocaleString() : item.value;
				          res += '<br/>' + item.seriesName + '：' + val + (item.seriesName.indexOf('金額') > -1 ? moneyMark : '');
				        }
				        return res;
				      }
				    },
				    // 基础图例配置（初始化时先渲染）
			    // ===== 核心：legend 放在底部，居中，确保可见 =====
			    legend: {
			      data: [
			        '歴史税抜金額',
			        'AI予測税抜金額',
			        '歴史数量',
			        'AI予測数量'
			      ],
			      bottom: 0,       // 距离底部 10px
			      left: 'center',    // 水平居中
			      textStyle: { fontSize: 12 },
			      itemWidth: 12,
			      itemHeight: 12
			    },
			    // ===== 核心：grid 上移，给 legend 留空间 =====
			    grid: {
			      left: '4%',
			      right: '4%',
			      bottom: '20%',    // 底部留 15% 给 legend
			      top: '10%',
			      containLabel: true
			    },
			    xAxis: { type: 'category', boundaryGap: false, data: [] },
				// 	// ===== 核心：yAxis 必须是数组，且有 2 个轴（0 和 1）=====
			    // yAxis: [
			    //   { type: 'value', name: '金額', position: 'left', scale: true },
			    //   { type: 'value', name: '数量', position: 'right', scale: true }
			    // ],
				
				yAxis: [
				  {
				    type: 'value',
				    name: '金額',
				    position: 'left',
				    scale: true,
				    axisLabel: { formatter: '{value} ' + moneyMark }
				  },
				  {
				    type: 'value',
				    name: '数量',
				    position: 'right',
				    scale: true,
				    axisLabel: { formatter: '{value}' }
				  }
				],
				    // 系列配置：样式+类型+轴绑定，一次定义
				    series: [
				      {
				        name: '歴史税抜金額',
				        type: 'line',
				        yAxisIndex: 0,
				        data: [],
				        lineStyle: { width: 2 , type: 'dashed'},
				        //itemStyle: { color: '#2c9fcb'},
						itemStyle: { 
						    color: 'transparent',  // 填充透明 → 空心
						    borderColor: '#2c9fcb',// 边框颜色（浅蓝）
						    borderWidth: 2         // 边框宽度（圈的粗细）
						  },
				        symbol: 'circle',
				        symbolSize: 6
				      },
				      {
				        name: 'AI予測税抜金額',
				        type: 'line',
				        yAxisIndex: 0,
				        data: [],
				        lineStyle: { width: 2, type: 'dashed' },
				        //itemStyle: { color:  '#1ab394' },
						itemStyle: {
						    color: 'transparent',  // 填充透明 → 空心
						    borderColor: '#1ab394',// 边框颜色（浅蓝）
						    borderWidth: 2         // 边框宽度（圈的粗细）
						  },
				        symbol: 'circle',
				        symbolSize: 8
				      },
				      {
				        name: '歴史数量',
				        type: 'line',
				        yAxisIndex: 1,
				        data: [],
				        lineStyle: { width: 2, type: 'dashed' },
				        //itemStyle: { color:  '#f8ac59' },
						itemStyle: {
						    color: 'transparent',  // 填充透明 → 空心
						    borderColor: '#f8ac59',// 边框颜色（浅蓝）
						    borderWidth: 2         // 边框宽度（圈的粗细）
						  },
				        symbol: 'circle',
				        symbolSize: 6
				      },
				      {
				        name: 'AI予測数量',
				        type: 'line',
				        yAxisIndex: 1,
				        data: [],
				        lineStyle: { width: 2, type: 'dashed' },
				        //itemStyle: { color: '#ff6b6b' },
						itemStyle: {
						    color: 'transparent',  // 填充透明 → 空心
						    borderColor: '#ff6b6b',// 边框颜色（浅蓝）
						    borderWidth: 2         // 边框宽度（圈的粗细）
						  },
				        symbol: 'circle',
				        symbolSize: 8
				      }
				    ]
			  };
			
			  this.aiForecastChart.setOption(baseOption);
			// // ===== 修复：resize 加延迟 + 判空，避免在主进程调用 =====
			  let resizeTimer = null;
			  window.addEventListener('resize', () => {
			    clearTimeout(resizeTimer);
			    resizeTimer = setTimeout(() => {
			      if (this.aiForecastChart) {
			        this.aiForecastChart.resize();
			      }
			    }, 300);
			  });
			},																
			// 打开AI预测弹窗	-整合打开弹窗方法，接收type参数（month/week）=====				
			openAIForecast(type) {
			  if (!this.query.start || !this.query.end) {
			    this.MBB_check('10101','売上日付','');
			    return;
			  }						  					
			   // 2. 转时间戳（new Date()可解析大部分时间格式：YYYY-MM-DD、YYYY-MM-DD HH:mm:ss等）
			   const startTime = new Date(this.query.start).getTime();
			   const endTime = new Date(this.query.end).getTime();
			   // 3. 处理开始时间大于结束时间的情况
			   if (startTime > endTime) {
				 this.$message({
				 	message: '開始日時は終了日時より遅くすることはできません。', //开始时间不能晚于结束时间
				 	type: 'warning'
				 });
			     return ;
			   }
			   // 【周预测改造】根据类型判断时间间隔（月≥7个月，周≥10周）
			   // 4. 计算时间差（毫秒），7个月按7*30天计算：3*30*24*60*60*1000
			   const timeDiff = endTime - startTime;
			   const threeMonthsMs = 7 * 30 * 24 * 60 * 60 * 1000;
			   const tenWeeksMs = 10* 7 * 24 * 60 * 60 * 1000;
			   // 5. 判断是否小于7个月
			   if(type === 'month' && timeDiff < threeMonthsMs){
				  //this.MBB_check('10101','売上日付','');
				  this.$message({
				  	message: '売上日付間隔は7ヶ月以上必要', //请求失败
				  	type: 'warning'
				  });
				  return; 
			   }	
			   if(type === 'week' && timeDiff < tenWeeksMs){
			   		  this.$message({
			   		  	message: '売上日付間隔は10週間以上必要',
			   		  	type: 'warning'
			   		  });
			   		  return; 
			   	}					
			    // 初始化预测数+设置类型标识
			    this.aiForecastType = type;
			    this.aiForecastForm.aiForecastNum = '1';											   
			  this.aiForecastTableData = [];
			  this.aiForecastDialogVisible = true;
			
			  // ===== 核心修复：延迟足够久，确保 DOM 已渲染、chart 已初始化 =====
			  setTimeout(() => {
			    this.initAIForecastChart(); // 先 init
			
			    // ===== 再延迟 200ms，等 init 完成，再请求 =====
			    setTimeout(() => {
			      this.getAIForecastData();
			    }, 200);
			  }, 500); // 总延迟 700ms，足够旧版 Vue/ECharts 完成渲染
			},
			// 关闭AI预测弹窗
			closeAIForecastDialog() {
			  this.aiForecastDialogVisible = false;
			  this.aiForecastLoading = false; // 重置加载状态
			  // 清空图表数据
			  if (this.aiForecastChart) {
			    this.aiForecastChart.setOption({
			      xAxis: { data: [] },
			      series: [
			        { data: [] }, { data: [] }, { data: [] }, { data: [] }
			      ]
			    }, true);
			  }
			},
			getAIForecastData() {
				  var self = this; 							
				  // 核心优化：设置全局加载状态，覆盖图表+按钮，避免分段加载
				  this.aiForecastLoading = true;
				  var queryBar = [{
				    start: this.query.start,
				    end: self.query.end,
				    MCCID: self.query.MCCID.join("-"),
				    MCDID: self.query.MCDID.join("-"),
				    POS01: self.query.POS01,
				    POS02: self.query.POS02,
				    POS03: self.query.POS03,
				    POS04: self.query.POS04,
				    DELFG: self.query.pDELFG
				  }];
					// 【周预测改造】根据类型选择接口地址和预测参数
					  const apiUrl = self.aiForecastType === 'month' 
					  	? 'BI/AI/Get_AISalesForecast' 
					  	: 'BI/AI/Get_AISalesForecastByWeek';
					  const forecastParam = self.aiForecastType === 'month' 
					  	? { ForecastMonths: self.aiForecastForm.aiForecastNum } 
					  	: { ForecastWeeks: self.aiForecastForm.aiForecastNum };					  
						this.$axios.post(apiUrl, {
							pMCBID: this.pMCBID,
							pCOMID: sessionStorage.getItem('CompanyCD'),
							pLNGCT: this.pLNGCT,
							qUERYTABLE: JSON.stringify(queryBar),
							//ForecastMonths: self.aiForecastForm.forecastMonths,
							...forecastParam, // 展开预测参数（月/周）
							pCOMNM: sessionStorage.getItem('CompanyName'),
							pMCCNM: sessionStorage.getItem('ShopName')
						})							 							  
				  .then(function(response) {						    
					 // 核心优化：请求完成后统一关闭加载状态
						 self.aiForecastLoading = false;
				if (response.data && response.data.KKDTCOUNT > 0) {
				      var res = JSON.parse(response.data.KKDT[0].data);
				      console.log('【AI预测后台数据】', res);
					  var Message =res.Message|| '予測失敗'// 兜底(res.Message当时null时)
					if (!Message.includes('success')) {
					 self.$message({ type: 'warning', message: Message });													
					 self.aiForecastDialogVisible = false;							
					}else{
						var chartLabels = res.ChartLabels || [];
						var historyAmount = res.HistoryAmount || [];
						var forecastAmount = res.ForecastAmount || [];
						var historyCount = res.HistoryCount || [];
						var forecastCount = res.ForecastCount || [];
						var xAxisLen = chartLabels.length;

						var fillHistoryAmt = historyAmount.concat(new Array(xAxisLen - historyAmount.length).fill(null));
						var fillHistoryCnt = historyCount.concat(new Array(xAxisLen - historyCount.length).fill(null));					
						// var fillForecastAmt = new Array(xAxisLen - forecastAmount.length).fill(null).concat(forecastAmount);
						// var fillForecastCnt = new Array(xAxisLen - forecastCount.length).fill(null).concat(forecastCount);
						//历史数量在预测月的值填充null，如果填充0则会有实质的折现图
						//预测月的数量在历史月也填充null，如果预测开始月需要和历史数量连接，那么需要拼接历史的最后一个月的数量值
						
						// 2. 预测数据：前面补 null，
						var fillForecastAmt = new Array(xAxisLen - forecastAmount.length).fill(null);
						var fillForecastCnt = new Array(xAxisLen - forecastCount.length).fill(null);
						
						// ✅ 关键：如果有历史数据，把预测数组的【历史最后一个点】位置，设为历史最后一个值
						if (historyAmount.length > 0) {
						  fillForecastAmt[fillForecastAmt.length - 1] = historyAmount[historyAmount.length - 1];
						}
						if (historyCount.length > 0) {
						  fillForecastCnt[fillForecastCnt.length - 1] = historyCount[historyCount.length - 1];
						}						
						// 再把预测数据拼到后面
						fillForecastAmt = fillForecastAmt.concat(forecastAmount);
						fillForecastCnt = fillForecastCnt.concat(forecastCount);
												
						var updateOption = {
								 title: {
								   text: `売上履歴 + AI${self.aiForecastType === 'month' ? '月別' : '週別'}予測趨勢（税抜金額/数量）`,
								   left: 'center',
								   textStyle: { fontSize: 14 }
								 },
								 // 强制渲染图例，和初始化配置一致，避免被覆盖
								 legend: {
								   data: ['歴史税抜金額', 'AI予測税抜金額', '歴史数量', 'AI予測数量'],
								   bottom: 0,
								   left: 'center',
								   textStyle: { fontSize: 12 },
								   itemWidth: 12,
								   itemHeight: 12,
								   itemGap: 15
								 },
								 // 网格布局和初始化一致，预留图例空间
								 grid: {
								   left: '4%',
								   right: '4%',
								   top: '10%',
								   bottom: '20%',
								   containLabel: true
								 },
						  xAxis: { data: chartLabels },
						  yAxis: [
						    { type: 'value', name: '金額', position: 'left', scale: true },
						    { type: 'value', name: '数量', position: 'right', scale: true }
						  ],
						  series: [
						    { name: '歴史税抜金額', type: 'line', yAxisIndex: 0, data: fillHistoryAmt },
						    { name: 'AI予測税抜金額',
							  type: 'line', 
							  yAxisIndex: 0,
							  data: fillForecastAmt ,
							  lineStyle: {  type: 'dashed' },//虚线
							},
						    { name: '歴史数量', type: 'line', yAxisIndex: 1, data: fillHistoryCnt },
						    { name: 'AI予測数量',
							  type: 'line', 
							  yAxisIndex: 1,
							  data: fillForecastCnt ,
							  lineStyle: {  type: 'dashed' },//虚线
							  }
						  ]
						};												
						// ===== 核心：用 self 访问 aiForecastChart =====
						if (self.aiForecastChart) {
						  self.aiForecastChart.setOption(updateOption, true);
						}
												
						self.aiForecastTableData = res.ForecastList || [];
						if (self.aiForecastTableData.length === 0) {
						  self.MBB_check('10010', '', 'AI予測データなし');
						}
					}							  							  
				} 							
					else {
				      self.MBB_check('10010', '', '');
				      self.aiForecastTableData = [];
				      if (self.aiForecastChart) {
				        self.aiForecastChart.setOption({
						legend: {
						            data: ['歴史税抜金額', 'AI予測税抜金額', '歴史数量', 'AI予測数量'],
						            bottom: 0,
						            left: 'center'
						          },
						          grid: {
						            left: '4%',
						            right: '4%',
						            top: '10%',
						            bottom: '20%'
						          },
				          xAxis: { data: [] },
						  yAxis: [
						    { type: 'value', name: '金額', position: 'left', scale: true },
						    { type: 'value', name: '数量', position: 'right', scale: true }
						  ],
				          series: [
				            { name: '歴史税抜金額', type: 'line', yAxisIndex: 0, data: [] },
				            { name: 'AI予測税抜金額', type: 'line', yAxisIndex: 0, data: [] },
				            { name: '歴史数量', type: 'line', yAxisIndex: 1, data: [] },
				            { name: 'AI予測数量', type: 'line', yAxisIndex: 1, data: [] }
				          ]
				        }, true);
				      }
				    }
					
				  }).catch(function(error) {
					 // 核心优化：异常时也关闭加载状态，避免界面卡死
					 	self.aiForecastLoading = false;
				        self.MBB_check('10181', '', '');
				    console.error('AI予測接口请求失败：', error);
				  });
			},						
			MONEYformatter(row, index) {
				return sessionStorage.getItem('MoneyMark')+Number(row.ForecastAmount).toLocaleString();
			},
			QUATYformatter(row, index) {
				return Number(row.ForecastCount).toLocaleString();
			},
// ===== 以下是原有方法，全部保留 =====
		    Get_MBA(page) {
				const self = this;
				var postUrl = 'FSMS/Public/Get_MBA';
				//网络请求接口
				this.$axios
					.post(
						//请求的url
						postUrl,
						//请求参数
						{
							APPID: page,
							Language: self.pLNGCT,
							pMCBID: this.pMCBID,
							CompanyCD: sessionStorage.getItem('CompanyCD'),
							pCOMNM:sessionStorage.getItem('CompanyName'),
							pMCCNM:sessionStorage.getItem('ShopName'),
						}
					)
					.then(response => {
						//请求成功返回的数据
						let resCount = response.data.KKDTCOUNT;
						if (resCount > 0) {
							let resKKDT = response.data.KKDT;
							self.lblMBA = resKKDT;
						}
					})
		    },
		   Get_MBB: async function(id,value1,value2) {
		      const self = this;
		      var postUrl = 'FSMS/Public/Get_MBB';
		      //网络请求接口
		      await this.$axios
		      	.post(
		      		//请求的url
		      		postUrl,
		      		//请求参数
		      		{
		      			pID:id ,
						pMCBID: this.pMCBID,
		      			pLanguage: self.pLNGCT,
						pCOMNM:sessionStorage.getItem('CompanyName'),
						pMCCNM:sessionStorage.getItem('ShopName'),
		      		}
		      	)
		      	.then(response => {
		      		//请求成功返回的数据
		      		let resCount = response.data.KKDTCOUNT;
		      
		      		if (resCount > 0) {
		      			self.strMBB = response.data.KKDT[0].MBBVALUE.toString().replace("{0}",value1).replace('{1}',value2).replace("\\n",'');
		      			if(response.data.KKDT[0].MBBALTCT.toString() == '0'){
		      				self.strType = 'warning';//警告
		      			}else if(response.data.KKDT[0].MBBALTCT.toString() == '1'){
		      				self.strType = 'error';//问题
		      			}else{
		      				self.strType = 'info';//通知
		      			}						
		      		}
		      	})
		     },
		     MBB_check: async function(id,value1,value2){
		     	    await this.Get_MBB(id,value1,value2);		 	
		   	    this.$message({
		   	    	message: this.strMBB, 
		   	    	type: this.strType
		   	    });
		      },

			//店铺
			Get_MCC_List() {
				const self = this;
				var postUrl = 'FSMS/Public/Get_MCC_List';
				//网络请求接口
				this.$axios
					.post(
						//请求的url
						postUrl,
						//请求参数
						{
							pMCBID: self.pMCBID,
							pMCCID: self.pMCCID,
							pCOMID: sessionStorage.getItem('CompanyCD'),
							pCOMNM:sessionStorage.getItem('CompanyName'),
							pMCCNM:sessionStorage.getItem('ShopName'),
						}
					)
					.then(response => {
						//请求成功返回的数据
						let resCount = response.data.KKDTCOUNT;
						if (resCount > 0) {
							let resKKDT = response.data.KKDT;
							this.query.optionsMCCID = resKKDT;
						}
					})
					.catch(error => {
                        this.MBB_check('10181','','');//通信エラーが発生しました。
					});
			},

			//店铺グループ
			Get_MCD_List() {
				const self = this;
				var postUrl ='FSMS/Public/Get_MCD_List';
				//网络请求接口
				this.$axios
					.post(
						//请求的url
						postUrl,
						//请求参数
						{
							pMCBID: self.pMCBID,
							pMCCID: self.pMCCID,
							pMCDID: self.pMCDID,
							pCOMID: sessionStorage.getItem('CompanyCD'),
							pCOMNM:sessionStorage.getItem('CompanyName'),
							pMCCNM:sessionStorage.getItem('ShopName'),
						}
					)
					.then(response => {
						//请求成功返回的数据
						let resCount = response.data.KKDTCOUNT;
						if (resCount > 0) {
							let resKKDT = response.data.KKDT;
							this.query.optionsMCDID = resKKDT;
						}
					})
					.catch(error => {
                        this.MBB_check('10181','','');//通信エラーが発生しました。
					});
			},
			//性别
			Get_INI1_List() {
				const self = this;
				var postUrl = 'FSMS/Public/Get_INIInfo_List';
				//网络请求接口
				this.$axios
					.post(
						//请求的url
						postUrl,
						//请求参数
						{
							pMCBID: self.pMCBID,
							pMCCID: self.pMCCID,
							pCOMID: "",
							pLNGCT: self.pLNGCT, //语言
							pKEY01: "10007",
							pCOMNM:sessionStorage.getItem('CompanyName'),
							pMCCNM:sessionStorage.getItem('ShopName'),

						}
					)
					.then(response => {
						//请求成功返回的数据
						let resCount = response.data.KKDTCOUNT;
						if (resCount > 0) {
							let resKKDT = response.data.KKDT;
							this.query.optionsPOS01 = resKKDT;
						}
					})
					.catch(error => {
							this.MBB_check('10181','','');//通信エラーが発生しました。
					});
			},
			//需要
			Get_INI2_List() {
				const self = this;
				var postUrl = 'FSMS/Public/Get_INIInfo_List';
				//网络请求接口
				this.$axios
					.post(
						//请求的url
						postUrl,
						//请求参数
						{
							pMCBID: self.pMCBID,
							pMCCID: self.pMCCID,
							pCOMID: "",
							pLNGCT: self.pLNGCT, //语言
							pKEY01: "10008",
							pCOMNM:sessionStorage.getItem('CompanyName'),
							pMCCNM:sessionStorage.getItem('ShopName'),

						}
					)
					.then(response => {
						//请求成功返回的数据
						let resCount = response.data.KKDTCOUNT;
						if (resCount > 0) {
							let resKKDT = response.data.KKDT;
							this.query.optionsPOS02 = resKKDT;
						}
					})
					.catch(error => {
							this.MBB_check('10181','','');//通信エラーが発生しました。
					});
			},
			//客層
			Get_INI3_List() {
				const self = this;
				var postUrl = 'FSMS/Public/Get_INIInfo_List';
				//网络请求接口
				this.$axios
					.post(
						//请求的url
						postUrl,
						//请求参数
						{
							pMCBID: self.pMCBID,
							pMCCID: self.pMCCID,
							pCOMID: "",
							pLNGCT: self.pLNGCT, //语言
							pKEY01: "10009",
							pCOMNM:sessionStorage.getItem('CompanyName'),
							pMCCNM:sessionStorage.getItem('ShopName'),

						}
					)
					.then(response => {
						//请求成功返回的数据
						let resCount = response.data.KKDTCOUNT;
						if (resCount > 0) {
							let resKKDT = response.data.KKDT;
							this.query.optionsPOS03 = resKKDT;
						}
					})
					.catch(error => {
							this.MBB_check('10181','','');//通信エラーが発生しました。
					});
			},
			//年代
			Get_INI4_List() {
				const self = this;
				var postUrl = 'FSMS/Public/Get_INIInfo_List';
				//网络请求接口
				this.$axios
					.post(
						//请求的url
						postUrl,
						//请求参数
						{
							pMCBID: self.pMCBID,
							pMCCID: self.pMCCID,
							pCOMID: "",
							pLNGCT: self.pLNGCT, //语言
							pKEY01: "10010",
							pCOMNM:sessionStorage.getItem('CompanyName'),
							pMCCNM:sessionStorage.getItem('ShopName'),

						}
					)
					.then(response => {
						//请求成功返回的数据
						let resCount = response.data.KKDTCOUNT;
						if (resCount > 0) {
							let resKKDT = response.data.KKDT;
							this.query.optionsPOS04 = resKKDT;
						}
					})
					.catch(error => {
							this.MBB_check('10181','','');//通信エラーが発生しました。
					});
			},
			//会員ランク
			Get_INI5_List() {
				const self = this;
				var postUrl = 'FSMS/Public/Get_INIInfo_List';
				//网络请求接口
				this.$axios
					.post(
						//请求的url
						postUrl,
						//请求参数
						{
							pMCBID: self.pMCBID,
							pMCCID: self.pMCCID,
							pCOMID: sessionStorage.getItem('CompanyCD'),
							pLNGCT: self.pLNGCT, //语言
							pKEY01: "10045",
							pCOMNM:sessionStorage.getItem('CompanyName'),
							pMCCNM:sessionStorage.getItem('ShopName'),
			
						}
					)
					.then(response => {
						//请求成功返回的数据
						let resCount = response.data.KKDTCOUNT;
						if (resCount > 0) {
							let resKKDT = response.data.KKDT;
							this.query.optionsPBARNKCT = resKKDT;
						}
					})
					.catch(error => {
							this.MBB_check('10181','','');//通信エラーが発生しました。
					});
			},
			//获取INI
			Get_INI() {
				const self = this;
				var postUrl = 'FSMS/Public/Get_INI_List';
				//网络请求接口
				this.$axios
					.post(
						//请求的url
						postUrl,
						//请求参数
						{
							pMCBID: self.pMCBID,
							pMCCID: self.pMCCID,
							pCOMID: sessionStorage.getItem('CompanyCD'),
							pLNGCT: self.pLNGCT, //语言
							pKEY01: '30004',
							pCOMNM:sessionStorage.getItem('CompanyName'),
							pMCCNM:sessionStorage.getItem('ShopName'),
						}
					)
					.then(response => {
						//请求成功返回的数据
						let resCount = response.data.KKDTCOUNT;
						if (resCount > 0) {
							let resKKDT = response.data.KKDT;
							let arrROW = []; //获取行数据
							let arrLIST = []; //获取列数据
							let arrSETMETER = []; //获取集计数据
							//0、1、2：lable区分：0行数据，1列数据，2集计数据
							for (let list of resKKDT) {
								let obj = {};
								if (list.INIMNAME == '0') {
									obj = list;
									arrROW.push(obj);
								} else if (list.INIMNAME == '1') {
									obj = list;
									arrLIST.push(obj);
								} else {
									obj = list;
									arrSETMETER.push(obj);
								}
							}
							self.datarow = arrROW;
							self.datacol = arrLIST;
							self.checkitem = arrSETMETER;

						}
					})
					.catch(error => {
						this.MBB_check('10181','','');//通信エラーが発生しました。
					});
			},
			//获取页面名
			Get_BAG_List(){
				const self = this;
				var postUrl = 'FSMS/Public/Get_BAG_List';
				//网络请求接口
				this.$axios
					.post(
						//请求的url
						postUrl,
						//请求参数
						{
							pMCBID: self.pMCBID,
							pMCCID: self.pMCCID,
							pCOMID: sessionStorage.getItem('CompanyCD'),
							pLNGCT: self.pLNGCT, //语言
							pCOMNM:sessionStorage.getItem('CompanyName'),
							pMCCNM:sessionStorage.getItem('ShopName'),
							pPATH: "/FSBI/Analysis_sales/Analysis_sales",
						}
					)
					.then(response => {
						//请求成功返回的数据
						this.PAGENAME = response.data.KKSTR;
					})
					.catch(error => {
						this.MBB_check('10181','','');//通信エラーが発生しました。
					});
			},

			getcolcount(col, lpx, rows, jj) {

				rows = rows.toString().substring(0, rows.length - 1);
				if (this.query.start == null || this.query.end == null) {
					this.MBB_check('10101','売上日付','');
					this.$refs.itemfile.loadflag = false;
					return;
				}

				const self = this;
				let queryBar = [];
				// this.collist=[];
				let obj = {};
				obj.start = this.query.start;
				obj.end = self.query.end;
				obj.MCCID = self.query.MCCID.join("-");
				obj.MCDID = self.query.MCDID.join("-");
				obj.PBARNKCT = self.query.PBARNKCT.join("-");//会员等级
				/* obj.MEAID = self.query.MEAID.join("-");
				obj.MEBID = self.query.MEBID;
				obj.MECID = self.query.MECID;
				obj.MEDID = self.query.MEDID;
				obj.MEENM = self.query.MEENM;
				obj.MDAID = self.query.MDAID; */
				obj.POS01 = self.query.POS01;
				obj.POS02 = self.query.POS02;
				obj.POS03 = self.query.POS03;
				obj.POS04 = self.query.POS04;
				/* obj.MDHNM1 = self.query.MDHNM1;
				obj.MDHNM2 = self.query.MDHNM2;
				obj.MDMNM = self.query.MDMNM; */
				obj.DELFG = self.query.pDELFG;
				queryBar.push(obj);
				let url = 'BI/BI/Get_TAASUM_Count';
				this.$axios.post(
						url, {

							pMCBID: this.pMCBID,
							pMCCID: '',
							pMCDID: '',
							pCOMID: sessionStorage.getItem('CompanyCD'),
							pLNGCT: this.pLNGCT, //语言
							column: col, //勾选列字段
							qUERYTABLE: JSON.stringify(queryBar),
							rows:rows,
							pCOMNM:sessionStorage.getItem('CompanyName'),
							pMCCNM:sessionStorage.getItem('ShopName'),
						}

					).then((response) => {
						//请求成功返回的数据

						this.query.count = response.data.KKDTCOUNT;

						if (this.query.count > 0) {
							if (col.split(',').length > 1 && jj.length > 1) {
								if (this.query.count > 10000) {
									this.MBB_check('10197','データ件数','10000');//{0}が{1}件を超えています。検索条件を見直してください
									this.$refs.itemfile.loadflag = false;
									return;
								} else {
									this.getcol(col,rows,jj, lpx);
								}
							} else {

								if (this.query.count > 30000) {
									this.MBB_check('10197','データ件数','30000');//{0}が{1}件を超えています。検索条件を見直してください
									this.$refs.itemfile.loadflag = false;
									return;
								} else {
									this.getcol(col,rows,jj, lpx);
								}
							}
						} else {

							this.datasource = [];
							this.MBB_check('10010','','');//沒有滿足條件的資料。
							sessionStorage.setItem('Loading', false);
							this.$refs.itemfile.loadflag = false;
						}
					})
					.catch((error) => {
						this.MBB_check('10181','','');//通信エラーが発生しました。
					});

			},

			getcol(col,rows,jj, lpx) {
				this.datasource = [];
				const self = this;
				let queryBar = [];
				// this.collist=[];
				let obj = {};   
				obj.start = this.query.start;
				obj.end = self.query.end;
				obj.MCCID = self.query.MCCID.join("-");
				obj.MCDID = self.query.MCDID.join("-");
				obj.PBARNKCT = self.query.PBARNKCT.join("-");//会员等级
				/* obj.MEAID = self.query.MEAID.join("-");
				obj.MEBID = self.query.MEBID;
				obj.MECID = self.query.MECID;
				obj.MEDID = self.query.MEDID;
				obj.MEENM = self.query.MEENM;
				obj.MDAID = self.query.MDAID; */
				obj.POS01 = self.query.POS01;
				obj.POS02 = self.query.POS02;
				obj.POS03 = self.query.POS03;
				obj.POS04 = self.query.POS04;
				/* obj.MDHNM1 = self.query.MDHNM1;
				obj.MDHNM2 = self.query.MDHNM2;
				obj.MDMNM = self.query.MDMNM; */
				obj.DELFG = self.query.pDELFG;
				queryBar.push(obj);
				let url = 'BI/BI/Get_TAASUM_List';
				this.$axios.post(
						url, {

							ShopCD: '',
							pMCBID: this.pMCBID,
							pMCCID: '',
							pMCDID: '',
							pCOMID: sessionStorage.getItem('CompanyCD'),
							pLNGCT: this.pLNGCT, //语言
							rows: rows,//勾选行字段
							jj: jj,//勾选集计字段
							column: col, //勾选列字段
							lpx: lpx, // 排序
							qUERYTABLE: JSON.stringify(queryBar),
							pCOMNM:sessionStorage.getItem('CompanyName'),
							pMCCNM:sessionStorage.getItem('ShopName'),

						}

					).then((response) => {
						//请求成功返回的数据
						if (response.data.KKDTCOUNT > 0) {
							this.collist = response.data.KKDT;

						} else {
							this.collist = [];
						}

					})
					.catch((error) => {
						this.MBB_check('10181','','');//通信エラーが発生しました。
					});

			},

			getCount(row, col, jj, rpx, valtype) {
				this.datasource = [];
				this.query.total = 0;
				row = row.toString().substring(0, row.length - 1);
				jj = jj.toString().substring(0, jj.length - 1);
				valtype = valtype.toString().substring(0, valtype.length - 1);
				let url = 'FSMS/Public/Get_Count';
				this.$axios.post(
						url, {
							ShopCD: '',
							pMCBID: this.pMCBID,
							pMCCID: '',
							pMCDID: '',
							pCOMID: sessionStorage.getItem('CompanyCD'),
							pLNGCT: this.pLNGCT, //语言
							row: row, //勾选行字段
							col: col, // 列
							jj: jj,
							sessioname: 'Analysissales',
							pCOMNM:sessionStorage.getItem('CompanyName'),
							pMCCNM:sessionStorage.getItem('ShopName'),
						}

					).then((response) => {
						this.query.total = 0;
						//请求成功返回的数据
						this.query.total = Number(response.data.KKDTCOUNT);

						if (this.query.total > 0) {
							this.rows = row;
							this.cols = col;
							this.jjs = jj;
							this.rpx = rpx;
							this.valtype = valtype;

							this.getSource(1);
						} else {
							this.query.total = 0;
							this.datasource = [];
						}
					})
					.catch((error) => {
						this.MBB_check('10181','','');//通信エラーが発生しました。
					});
			},
			getSource(page) {
				this.datasource = [];
				let url = 'FSMS/Public/Get_Source';
				this.$axios.post(
						url, {
							ShopCD: '',
							pMCBID: this.pMCBID,
							pMCCID: '',
							pMCDID: '',
							pCOMID: sessionStorage.getItem('CompanyCD'),
							pLNGCT: this.pLNGCT, //语言
							RolKey: this.rows, //勾选行字段
							ColKey: this.cols, // 列
							SvlKey: this.jjs, //集集
							sessioname: 'Analysissales', //跟自己页面的wcf session名字得对上
							rpx: this.rpx,
							valtype: this.valtype,
							pageSize: this.query.pageSize,
							pageIndex: page,
                            MoneyMark:sessionStorage.getItem('MoneyMark'),
							pCOMNM:sessionStorage.getItem('CompanyName'),
							pMCCNM:sessionStorage.getItem('ShopName'),
						
						}

					).then((response) => {
						//请求成功返回的数据
						this.$refs.itemfile.loadflag = false;
						this.datasource = response.data.KKDT;
						this.$refs.itemfile.datasource = this.datasource;
					})
					.catch((error) => {
						this.MBB_check('10181','','');//通信エラーが発生しました。
					});
			},

			handleSizeChange(size) {
				this.$refs.itemfile.loadflag = true;
				this.query.pageIndex = 1;
				this.query.pageSize = size;
				this.getSource(1);

			},
			handlePageChange(curpage) {
				this.$refs.itemfile.loadflag = true;
				// this.$set(this.query,"pageIndex",curpage);
				this.query.pageIndex = curpage;
				this.getSource(curpage);

			},
			exportcsv() {
				let name = '';
				let csvrowname = this.$refs.itemfile.csvrowname;
				let csvjjname = this.$refs.itemfile.csvjjname;

				if (csvjjname.length > 0) {
					csvjjname = csvjjname.substring(0, csvjjname.length - 1);
					name = csvrowname + csvjjname;
				} else {
					csvrowname = csvrowname.substring(0, csvrowname.length - 1);
					name = csvrowname;
				}

				let url = 'FSMS/Public/GetExport';
				this.$axios.post(
						url, {
							ShopCD: '',
							pMCBID: this.pMCBID,
							pMCCID: this.pMCCID,
							pMCDID: this.pMCDID,
							pCOMID: sessionStorage.getItem('CompanyCD'),
							pLNGCT: this.pLNGCT, //语言
							pTimeZone: sessionStorage.getItem('TimeZone'),
							pIP: sessionStorage.getItem('IP'),
							thHead: name,
							printType: "csv",
							pagenm: this.PAGENAME,
							pageid: 'sys_Analysis_sales',
							pCOMNM:sessionStorage.getItem('CompanyName'),
							pMCCNM:sessionStorage.getItem('ShopName'),

						}

					).then((response) => {
						//请求成功返回的数据
						let url = response.data.KKSTR;
						if(url != "False") {
							window.open(this.basehtmlURL + url);
						}
						else{
							this.MBB_check('10238','','');//数据打印失败。
						}			  		
					})
					.catch((error) => {
						this.MBB_check('10181','','');//通信エラーが発生しました。
					});

			},

			reset() {
				this.reload();
			},
			// 图表自适应方法（原有）
			handleChartResize() {
				clearTimeout(this.resizeTimer);
				this.resizeTimer = setTimeout(() => {
					if (this.aiForecastChart) {
						this.aiForecastChart.resize();
					}
				}, 300);	
			}
		}
	};
</script>

<style scoped>
	.handle-box {
		margin-bottom: 20px;
		width: 50%;
		float: left;
	}

	.red {
		color: #ff0000;
	}

	.black {
		color: #000000;
	}

	.mr10 {
		margin-right: 10px;
	}

	.table-td-thumb {
		display: block;
		margin: auto;
		width: 40px;
		height: 40px;
	}

	.el-row {
		margin-top: 15px;
	}

	.bg-purple {
		text-align: left;
	}

	.bg-purple-light {
		text-align: right;
	}

	.grid-content {
		min-height: 34px;
	}

	.green {
		color: green;
	}

	.blue {
		color: #00aaff;
	}

	.orange {
		color: #ff5500;
	}

	.handle-select {
		width: 70%;
	}

	.handle-selectn {
		width: 70%;
	}

	.handle-time {
		width: 90%;
	}

	.grid-contentn {
		min-height: 36px;
	}

	.lable-site {
		width: 40px;
		height: 40px;
	}

	.col-width {
		width: 170%;
	}
	/* AI图表弹窗样式优化 */
	:deep(.el-dialog__body) {
		padding: 20px;
	}
	:deep(.el-radio-group) {
		margin-right: 10px;
	}
	/* 加载样式优化：让文字更清晰 */
	:deep(.el-loading-text) {
		font-size: 14px;
		color: #666;
	}
</style>
